import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Plus, Trash2 } from 'lucide-react';

const CredentialsSection = ({ credentialInputs, setCredentialInputs, allCredentialTypes, updateForm }) => {
  const handleAdd = () => {
    setCredentialInputs([...credentialInputs, { label: 'User ID', value: '', customLabel: '' }]);
  };

  const handleRemove = (index) => {
    setCredentialInputs(credentialInputs.filter((_, i) => i !== index));
  };

  const handleChange = (index, field, value) => {
    const updated = [...credentialInputs];
    updated[index][field] = value;
    setCredentialInputs(updated);
    const creds = updated.map(c => ({
      label: c.label === 'Custom' ? c.customLabel : c.label,
      value: c.value
    })).filter(c => c.label && c.value);
    updateForm('credentials', creds);
  };

  return (
    <div className="p-4 bg-indigo-50 rounded-lg border border-indigo-200 space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-semibold text-sm text-indigo-800">Login Credentials</h3>
          <p className="text-xs text-indigo-600 mt-0.5">Add bank-specific login details (User ID, Password, PIN, etc.)</p>
        </div>
        <Button type="button" onClick={handleAdd} variant="outline" size="sm" className="gap-1 border-indigo-300 text-indigo-700" data-testid="add-credential-btn">
          <Plus className="w-3 h-3" />
          Add Credential
        </Button>
      </div>
      {credentialInputs.length > 0 && (
        <div className="space-y-3">
          {credentialInputs.map((cred, idx) => (
            <div key={`${cred.label}-${idx}`} className="flex items-end gap-2" data-testid={`credential-row-${idx}`}>
              <div className="w-48">
                <Label className="text-xs">Field Type</Label>
                <Select value={cred.label} onValueChange={(val) => handleChange(idx, 'label', val)}>
                  <SelectTrigger className="h-9" data-testid={`cred-type-${idx}`}><SelectValue /></SelectTrigger>
                  <SelectContent>
                    {allCredentialTypes.map(t => <SelectItem key={t} value={t}>{t}</SelectItem>)}
                    <SelectItem value="Custom">Custom...</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              {cred.label === 'Custom' && (
                <div className="w-36">
                  <Label className="text-xs">Custom Label</Label>
                  <Input className="h-9" value={cred.customLabel} onChange={(e) => handleChange(idx, 'customLabel', e.target.value)} placeholder="e.g. OTP Key" data-testid={`cred-custom-${idx}`} />
                </div>
              )}
              <div className="flex-1">
                <Label className="text-xs">Value</Label>
                <Input className="h-9" value={cred.value} onChange={(e) => handleChange(idx, 'value', e.target.value)} placeholder="Enter value" data-testid={`cred-value-${idx}`} />
              </div>
              <Button type="button" onClick={() => handleRemove(idx)} variant="ghost" size="sm" className="h-9 w-9 p-0 text-red-500 hover:bg-red-50">
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          ))}
        </div>
      )}
      {credentialInputs.length === 0 && (
        <p className="text-xs text-indigo-500 text-center py-2">No credentials added yet. Click "Add Credential" above.</p>
      )}
    </div>
  );
};

export default CredentialsSection;
